import { Layout } from "components/Layout/Layout";
import { useNotificationAccountDetails } from "./hooks";
import { Notifications } from "./Notifications";

export const NotificationsPage = () => {
  const { accountsError, accountsLoading, transformedAccounts } =
    useNotificationAccountDetails();
  return (
    <Layout>
      <Layout.Header>Notifications</Layout.Header>
      <Layout.Main>
        <Notifications
          accountsError={accountsError}
          accountsLoading={accountsLoading}
          accounts={transformedAccounts}
        />
      </Layout.Main>
    </Layout>
  );
};
